import useMemberMessageSummary from "../../../../hooks/use-member-message-summary";
import StatCard from "../../../../components/StatCard";
import { StatSummary } from "../../../../components/StatSummary";
import Grid from "@mui/material/Grid";
import ChartCard from '../../../../components/chart/chart-card';
import DoughnutChart from '../../../../components/chart/doughnut-chart';
import { MessageStatus } from '../../../../shared/enums';
import SingleBarChart from '../../../../components/chart/single-bar-chart';
import { MessageIcon } from "../../../../shared/icons";

export const getColorForStatus = (status: MessageStatus) => {
    switch (status) {
        case MessageStatus.READ:
            return '#2964d6';
        case MessageStatus.DELIVERED:
            return '#00C49F';
        case MessageStatus.SENT:
            return '#eacaf4';
        case MessageStatus.QUEUED:
            return '#c7ca1bff';
        case MessageStatus.UNDELIVERED:
            return '#ff0081';
        case MessageStatus.FAILED:
            return '#ed2f4f';
        default:
            return '#b9f8f6ff';
    }
}

const MemberMessageSummary = () => {
    const messageSummary = useMemberMessageSummary();

    const getSuccessRate = () => {
        if (messageSummary?.countByStatus) {
            const deliveredCount = messageSummary.countByStatus.find(item => item.key.toLowerCase() === MessageStatus.DELIVERED)?.value || 0;
            const readCount = messageSummary.countByStatus.find(item => item.key.toLowerCase() === MessageStatus.READ)?.value || 0;
            const successCount = deliveredCount + readCount;
            const totalCount = messageSummary.countByStatus.reduce((acc, item) => acc + (item.value ?? 0), 0);
            return totalCount > 0 ? ((successCount / totalCount) * 100).toFixed(2) + '%' : '0%';
        }
        return '0%';
    };

    const currentCycleTotal = messageSummary?.currentCycleTotal ?? 0;
    const freeQuotaRemaining = messageSummary?.freeQuotaRemaining ?? 0;
    const currentYearTotal = messageSummary?.currentYearTotal ?? 0;
    const countByStatus = messageSummary?.countByStatus ?? [];
    const countByType = messageSummary?.countByType ?? [];
    const dailyMessageTrend = messageSummary?.dailyMessageTrend ?? [];

    return (
        <div>
            {messageSummary &&
                <>
                    <StatSummary>
                        {/* <StatCard title={`Today`} value={messageSummary?.todayTotal.toLocaleString()} icon={MessageIcon} /> */}
                        <StatCard title={`Current Billing Cycle`} value={currentCycleTotal.toLocaleString()} icon={MessageIcon} />
                        <StatCard title={`Remaining Free Quota`} value={freeQuotaRemaining.toLocaleString()} icon={MessageIcon} />
                        {/* <StatCard title={`Success Rate`} value={getSuccessRate()} icon={MessageIcon} /> */}
                        <StatCard title={`This Year`} value={currentYearTotal.toLocaleString()} icon={MessageIcon} />
                    </StatSummary>
                    <Grid container direction="row" justifyContent="flex-start">
                        {/* <Grid item lg={5} md={6} sm={12} xs={12}>
                            <ChartCard><SingleBarChart data={messageSummary.monthlyTotals.map(item => { return { name: item.key, value: item.value } })} label={`Monthly Income (${CURRENCY})`} height={204} xAxisAngle={-90} /></ChartCard>
                        </Grid> */}
                        <Grid size={{ lg: 3, md: 6, sm: 12, xs: 12 }}>
                            <ChartCard><DoughnutChart data={countByStatus.map(item => { return { name: item.key, value: item.value ?? 0, color: getColorForStatus(item.key as MessageStatus) } })} label='Count by Status' /></ChartCard>
                        </Grid>
                        <Grid size={{ lg: 3, md: 6, sm: 12, xs: 12 }}>
                            <ChartCard><DoughnutChart data={countByType.map(item => { return { name: item.key, value: item.value ?? 0 } })} label='Count by Type' /></ChartCard>
                        </Grid>
                        <Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <ChartCard><SingleBarChart data={dailyMessageTrend.map(item => { return { name: item.key, value: item.value ?? 0 } })} label='Daily Messages' height={204} xAxisInterval={7} /></ChartCard>
                        </Grid>
                    </Grid>
                </>
            }
        </div>
    )
}

export default MemberMessageSummary;